/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Checkinflyerlanguage2Inputs */

const en_checkinflyerlanguage2 = /** @type {(inputs: Checkinflyerlanguage2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Language`)
};

const de_checkinflyerlanguage2 = /** @type {(inputs: Checkinflyerlanguage2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sprache`)
};

/**
* | output |
* | --- |
* | "Language" |
*
* @param {Checkinflyerlanguage2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const checkinflyerlanguage2 = /** @type {((inputs?: Checkinflyerlanguage2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Checkinflyerlanguage2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_checkinflyerlanguage2(inputs)
	return de_checkinflyerlanguage2(inputs)
});
export { checkinflyerlanguage2 as "checkinFlyerLanguage" }